import {
  ForgeChatMessage,
  ForgeChatMessageSender,
  ForgeChatMessageSenderType,
  ForgeChatThread,
} from "@supernova-studio/model";
import { z } from "zod";

export const DTOForgeChatMessage = ForgeChatMessage;
export type DTOForgeChatMessage = z.infer<typeof DTOForgeChatMessage>;

export const DTOForgeChatThread = ForgeChatThread;
export type DTOForgeChatThread = z.infer<typeof DTOForgeChatThread>;

export const DTOForgeChatMessageSenderType = ForgeChatMessageSenderType;
export type DTOForgeChatMessageSenderType = z.infer<typeof DTOForgeChatMessageSenderType>;

export const DTOForgeChatMessageSender = ForgeChatMessageSender;
export type DTOForgeChatMessageSender = z.infer<typeof DTOForgeChatMessageSender>;

/**
 * POST /api/v1/workspaces/{wsId}/forge/chat-threads
 */
export const DTOForgeChatThreadCreateInput = z.object({
  title: z.string().optional(),
});
export type DTOForgeChatThreadCreateInput = z.infer<typeof DTOForgeChatThreadCreateInput>;

/**
 * POST /api/v1/workspaces/{wsId}/forge/threads
 */
export const DTOForgeChatThreadCreateResponse = z.object({
  thread: DTOForgeChatThread,
});
export type DTOForgeChatThreadCreateResponse = z.infer<typeof DTOForgeChatThreadCreateResponse>;

/**
 * PUT /api/v1/workspaces/{wsId}/forge/threads/{threadId}
 */
export const DTOForgeChatThreadUpdateInput = z.object({
  title: z.string(),
});
export type DTOForgeChatThreadUpdateInput = z.infer<typeof DTOForgeChatThreadUpdateInput>;

/**
 * PUT /api/v1/workspaces/{wsId}/forge/threads/{threadId}
 */
export const DTOForgeChatThreadUpdateResponse = z.object({
  thread: DTOForgeChatThread,
});
export type DTOForgeChatThreadUpdateResponse = z.infer<typeof DTOForgeChatThreadUpdateResponse>;

/**
 * DELETE /api/v1/workspaces/{wsId}/forge/threads/{threadId}
 */
export const DTOForgeChatThreadDeleteResponse = z.object({
  success: z.boolean(),
});
export type DTOForgeChatThreadDeleteResponse = z.infer<typeof DTOForgeChatThreadDeleteResponse>;

/**
 * GET /api/v1/workspaces/{wsId}/forge/threads
 */
export const DTOForgeChatThreadListQuery = z.object({
  limit: z.number().optional(),
  offset: z.number().optional(),
});
export type DTOForgeChatThreadListQuery = z.infer<typeof DTOForgeChatThreadListQuery>;

/**
 * GET /api/v1/workspaces/{wsId}/forge/threads
 */
export const DTOForgeChatThreadListResponse = z.object({
  threads: z.array(DTOForgeChatThread),
  pagination: z.object({
    offset: z.number(),
    limit: z.number(),
    total: z.number(),
  }),
});
export type DTOForgeChatThreadListResponse = z.infer<typeof DTOForgeChatThreadListResponse>;

/**
 * POST /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageCreateInput = z.object({
  payload: z.string(),
  sender: DTOForgeChatMessageSender.optional(),
  opikTraceId: z.string().optional(),
});

export type DTOForgeChatMessageCreateInput = z.infer<typeof DTOForgeChatMessageCreateInput>;

/**
 * POST /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageCreateResponse = z.object({
  message: DTOForgeChatMessage,
});
export type DTOForgeChatMessageCreateResponse = z.infer<typeof DTOForgeChatMessageCreateResponse>;

/**
 * GET /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageListQuery = z.object({
  limit: z
    .string()
    .optional()
    .transform(val => (val ? parseInt(val, 10) : undefined)),
  offset: z
    .string()
    .optional()
    .transform(val => (val ? parseInt(val, 10) : undefined)),
});

export type DTOForgeChatMessageListQuery = z.infer<typeof DTOForgeChatMessageListQuery>;

/**
 * GET /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageListResponse = z.object({
  messages: z.array(DTOForgeChatMessage),
  totalCount: z.number(),
  hasMore: z.boolean(),
});

export type DTOForgeChatMessageListResponse = z.infer<typeof DTOForgeChatMessageListResponse>;

export const DTOForgeChatMessageScoreInput = z.object({
  messageId: z.string(),
  name: z.string(),
  value: z.number(),
  categoryName: z.string().optional(),
  reason: z.string().optional(),
});

export const DTOForgeChatMessageScoreRequest = z.object({
  scores: DTOForgeChatMessageScoreInput.array(),
});

export type DTOForgeChatMessageScoreInput = z.infer<typeof DTOForgeChatMessageScoreInput>;
export type DTOForgeChatMessageScoreRequest = z.infer<typeof DTOForgeChatMessageScoreRequest>;
